import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './CardCount.scss';
import './CardCount-media.scss';
import { Props } from './interfaces';

const CardCount = ({ text, idx, color, numberCard, bg = false, height, noCut = false }: Props) => {
  const stylesMainCard = {
    gridRowStart: 1,
    gridRowEnd: 3,
    height: '100%',
  };

  const bgColor = idx === 0 && color ? { backgroundColor: color, ...stylesMainCard } : {};
  const heightCard = height ? { height } : {};

  return (
    <div
      className={`card-count${bg ? ' card-count_bg' : ''}${noCut ? ' card-count_no-cut' : ''}`}
      style={{ ...bgColor, ...heightCard }}
    >
      <p className="body2">{numberCard < 10 ? `0${numberCard}` : numberCard}</p>
      <h4
        dangerouslySetInnerHTML={{ __html: text }}
        className={idx === 0 && color ? `card-count__first` : ''}
      />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CardCount));
